// @flow
import JQueryView, { on } from '../common/JQueryView';

declare var $: any;

export default class ShowViewV2 extends JQueryView {
  interviewMovieId: string;
  interviewMovieChappters: any;
  tocItems = [];

  constructor(interviewMovieId: string, interviewMovieChapptersJson: any) {
    super('#sb-site');

    this.renderShortDescription();
    this.renderDescription();
    this.renderMembers();
    this.renderToc();
    this.renderOtherProjects();
    this.renderHideFaqListAnswer();
    this.renderYoutube(interviewMovieId, interviewMovieChapptersJson);
  }

  renderYoutube(interviewMovieId: string, interviewMovieChapptersJson: any) {
    let reloadYoutube = function() {
      if (window.YT) {
        onYouTubeIframeAPIReady();
        return;
      }
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag: any = document.getElementsByTagName('script')[0];
      // 下記if文について。
      // firstScriptTagがないという事はなさそうだが、
      // circleCIでFlowに指摘を受けたのでif分を入れている。
      if (firstScriptTag) {
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
      window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
    };
    reloadYoutube();

    var player;

    function onYouTubeIframeAPIReady() {
      player = new window.YT.Player('interview_movie', {
        height: '405',
        width: '720',
        playerVars: {
          autoplay: 0,
          controls: 1,
          rel: 0,
        },
        videoId: interviewMovieId,
      });
      window.player = player;
    }
    const TYClick = (target, startSec) => {
      $(target).click(function() {
        player.loadVideoById(interviewMovieId, startSec, 'large');
      });
    };
    let start_at;
    let interviewMovieChappters = JSON.parse(interviewMovieChapptersJson);
    interviewMovieChappters.forEach(function(elem) {
      if (elem.start_at === 0) {
        start_at = 0.001;
      } else {
        start_at = elem.start_at;
      }
      TYClick(`#chapter_id_${elem.id}`, start_at);
    });
  }

  renderShortDescription() {
    const selector = '.sp_tab_name';
    const tocSDTextList = [];

    $('#short_description')
      .find('.tabContent')
      .first()
      .addClass('is-active');

    $('#short_description')
      .find(selector)
      .each((i, item) => {
        const trimed = item.dataset.spTabName
          ? item.dataset.spTabName.trim()
          : item.textContent.trim();
        const text = trimed.replace('■ ', '').replace('■', '');
        if (text !== '') {
          tocSDTextList.push(text);
        }
      });
    if (tocSDTextList.length > 0) {
      let html = '';
      tocSDTextList.forEach((text, j) => {
        const addClassName = j === 0 ? 'is-current' : '';
        html += `\n<button class="btn_info_tab ${addClassName}">${text}</button>`;
      });
      $('#toc_sd_sp').html(html);
    } else {
      $('#toc_sd_sp').hide();
    }
  }

  renderDescription() {
    $('.pjdetail_article').each(i => {
      let article = $('.pjdetail_article').eq(i);
      let more_button_wrap = $('<div>', {
        class: 'pc-none',
      });
      let more_button = $('<button>', {
        class: 'more',
        text: '詳細を見る',
      });
      more_button_wrap.append(more_button);
      article.append(more_button_wrap);
    });
  }

  renderMembers() {
    $('.member-block').each(i => {
      let article = $('.member-block').eq(i);
      let member_more_button = $('<button>', {
        class: 'btn btn-lg btn-block btn-faq member_more_button',
        text: '＋ 続きを読む',
      });
      article.append(member_more_button);
    });
  }

  renderToc() {
    const article_selector = '.pjdetail_article';
    const mokuji_selector = '.mokuji';
    const mokuji_sub_selector = '.mokuji-sub';

    $(article_selector).each(i => {
      let article = $('.pjdetail_article').eq(i);
      let mokuji_ele = article.find(mokuji_selector).get(0);
      let mokuji_sub_ele = article.find(mokuji_sub_selector);
      let text;
      let toggle = false;
      let mokuji_sub_item = [];

      if (i === 0) {
        article.addClass('is-active');
      }

      if (mokuji_ele) {
        const trimed = mokuji_ele.dataset.tocTitle
          ? mokuji_ele.dataset.tocTitle.trim()
          : mokuji_ele.textContent.trim();
        text = trimed.replace('■ ', '').replace('■', '');
        if (mokuji_ele.classList.contains('toggle')) {
          toggle = true;
        }
      } else {
        text = '';
      }

      if (mokuji_sub_ele) {
        mokuji_sub_ele.each((j, item) => {
          let sub_text = '';
          let sub_index = '';
          const trimed = item.dataset.tocSubTitle
            ? item.dataset.tocSubTitle.trim()
            : item.textContent.trim();
          sub_text = trimed.replace('■ ', '').replace('■', '');
          sub_index = item.id || `toc-${i}-${j}`;
          if (item.id !== sub_index) {
            item.id = sub_index;
          }
          mokuji_sub_item.push({ sub_text, sub_index });
        });
      }

      this.tocItems.push({ text, toggle, mokuji_sub_item });
    });

    if (this.tocItems.length > 0) {
      let sidenav = $(document.createDocumentFragment());
      let bottomnav = $(document.createDocumentFragment());
      let index_list = $(document.createDocumentFragment());

      this.tocItems.forEach((item, j) => {
        let sidenav_sub;
        let sidenav_item = $('<button>', {
          class: 'tab-nav-item',
        });

        let sidenav_span = $('<span>', {
          class: item.toggle ? 'toggleButton' : 'navBtn',
          text: item.text,
        });
        if (item.toggle) {
          sidenav_item.addClass('-toggle');
        }
        sidenav_item.append(sidenav_span);

        if (item.mokuji_sub_item.length !== 0) {
          sidenav_sub = $('<div>', {
            class: 'toggleWrap',
          });
          item.mokuji_sub_item.forEach(item => {
            let sidenav_sub_item = $('<button>', {
              class: 'tab-nav-itemChild',
              text: item.sub_text,
              onclick: `location.href='#${item.sub_index}'`,
            });
            sidenav_sub.append(sidenav_sub_item);
          });
        }

        let bottomnav_item = $('<button>', {
          class: 'tab-bottom-item',
          text: item.text,
        });
        let index_list_item = $('<button>', {
          class: 'index-list-item',
          text: item.text,
        });

        if (j === 0) {
          sidenav_item.addClass('is-current');
          bottomnav_item.addClass('is-current');
        }
        if (j === 1) {
          bottomnav_item.addClass('next');
        }
        if (item.text === 'ご質問BOX') {
          sidenav_item.attr('id', 'question_sidenav');
          bottomnav_item.attr('id', 'question_bottomnav');
        }

        sidenav.append(sidenav_item);
        sidenav.append(sidenav_sub);
        bottomnav.append(bottomnav_item);
        index_list.append(index_list_item);
      });

      $('#pjdetail_sidenav').append(sidenav);
      $('#pjdetail_bottomnav').append(bottomnav);
      $('#index_list').append(index_list);
    } else {
      $('#pjdetail_sidenav').hide();
      $('#pjdetail_bottomnav').hide();
      $('#index_list').hide();
    }
  }

  renderOtherProjects() {
    document.addEventListener('turbolinks:before-cache', function() {
      $('.js-slick.slick-initialized').slick('unslick');
    });

    var projectNum = $('.projects_v2').find('.top-project .c-projectItem')
      .length;
    var projectInfinite;
    var projectCenterMode;
    var projectSlidesToShow;

    if (projectNum < 5) {
      $('.top-project .l-container').addClass('-item-4');
      projectInfinite = false;
      projectCenterMode = false;
      projectSlidesToShow = projectNum;
    } else {
      projectInfinite = true;
      projectCenterMode = false;
      projectSlidesToShow = 3;
    }

    $('.js-slick')
      .not('.slick-initialized')
      .slick({
        infinite: projectInfinite,
        autoplay: false,
        dots: false,
        slidesToShow: projectSlidesToShow,
        swipe: true,
        arrows: true,
        touchMove: false,
        variableWidth: true,
        centerMode: projectCenterMode,
        prevArrow: '<button class="slide-arrow slick-prev"></button>',
        nextArrow: '<button class="slide-arrow slick-next"></button>',
        responsive: [
          {
            breakpoint: 1599,
            settings: {
              slidesToShow: 3,
              swipe: true,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              swipe: true,
            },
          },
          {
            breakpoint: 1060,
            settings: {
              slidesToShow: 2,
              infinite: true,
              swipe: true,
            },
          },
          {
            breakpoint: 775,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              infinite: true,
              swipe: true,
            },
          },
        ],
      });
  }

  renderHideFaqListAnswer() {
    $('.faq-list__btn')
      .next()
      .hide();
  }

  // 画面左の項目をクリック
  @on('click .tab-nav-item')
  onClickTabNavItem(event: any) {
    let t = $('.tab-nav-item').index(event.currentTarget);
    const miriSecMove = 500;
    $('html, body').animate(
      { scrollTop: $('#sect_pjdtl').position().top },
      miriSecMove,
    );

    $('.tab-nav-item').removeClass('is-current');
    $(event.currentTarget).addClass('is-current');
    $('.pjdetail_article').removeClass('is-active');
    $('.pjdetail_article')
      .eq(t)
      .addClass('is-active');

    $('.tab-bottom-item').removeClass('is-current');
    $('.tab-bottom-item')
      .eq(t)
      .addClass('is-current');
    $('.tab-bottom-item').removeClass('is-current prev next');
    $('.tab-bottom-item')
      .eq(t)
      .addClass('is-current');
    $('.tab-bottom-item')
      .eq(t)
      .prev()
      .addClass('prev');
    $('.tab-bottom-item')
      .eq(t)
      .next()
      .addClass('next');
  }

  // SP時目次の項目クリック
  @on('click .index-list-item')
  onClickIndexListItem(event: any) {
    let e = $('.index-list-item').index(event.currentTarget);
    const miriSecMove = 500;
    $('html, body').animate(
      {
        scrollTop: $('.pjdetail_article')
          .eq(e)
          .offset().top,
      },
      miriSecMove,
    );

    $('.tab-nav-item').removeClass('is-current');
    $('.tab-nav-item')
      .eq(e)
      .addClass('is-current');
    $('.pjdetail_article').removeClass('is-active');
    $('.pjdetail_article')
      .eq(e)
      .addClass('is-active');
    $('.tab-bottom-item').removeClass('is-current');
    $('.tab-bottom-item')
      .eq(e)
      .addClass('is-current');
    $('.tab-bottom-item').removeClass('is-current prev next');
    $('.tab-bottom-item')
      .eq(e)
      .addClass('is-current');
    $('.tab-bottom-item')
      .eq(e)
      .prev()
      .addClass('prev');
    $('.tab-bottom-item')
      .eq(e)
      .next()
      .addClass('next');
    // 目次が閉じる挙動
    $('#content-index').css('bottom', '-100%');
    $('body').css('overflow', 'inherit');
  }

  // 質問BOXボタンをクリックした際の挙動
  @on('click .goFaq')
  onClickGoFaq() {
    $('.tab-nav-item').removeClass('is-current');
    $('#question_sidenav').addClass('is-current');
    $('.pjdetail_article').removeClass('is-active');
    $('#question_box').addClass('is-active');
    $('.tab-bottom-item').removeClass('is-current');
    $('#question_bottomnav').addClass('is-current');
    $('.tab-bottom-item').removeClass('is-current prev next');
    $('#question_bottomnav').addClass('is-current');
    $('#question_bottomnav')
      .prev()
      .addClass('prev');
    $('#question_bottomnav')
      .next()
      .addClass('next');
    const miriSecMove = 500;
    $('html, body').animate(
      { scrollTop: $('#question_box').offset().top },
      miriSecMove,
    );
  }

  // プロジェクトの詳細を見るボタンクリック
  @on('click .more')
  onClickMore(event: any) {
    let target = $(event.currentTarget);
    target.hide();
    target
      .parent()
      .parent()
      .addClass('is-show');
  }

  // 会社メンバーの詳細を見るボタンクリック
  @on('click .member_more_button')
  onClickMemberMore(event: any) {
    let target = $(event.currentTarget);
    target.hide();
    target.parent().addClass('is-show');
  }

  // SP時目次の項目クリック(トグルボタンをクリックしてメニューが開く様子)
  @on('click .toggleButton')
  onClickToggleButton(event: any) {
    $('.toggleWrap').removeClass('is-open');
    let t = $('.toggleButton').index(event.currentTarget);
    $('.toggleWrap')
      .eq(t)
      .addClass('is-open');
  }

  // 目次要素をクリックした際に開いていたトグルが閉じる挙動
  @on('click .navBtn')
  onClickNavBtn() {
    $('.toggleWrap').removeClass('is-open');
  }

  // 画面下の矢印「ビジネスモデル＞」をクリック
  @on('click .tab-bottom-item')
  onClickTabBottomItem(event: any) {
    let t = $('.tab-bottom-item').index(event.currentTarget);
    const miriSecMove = 700;
    $('html, body').animate(
      { scrollTop: $('#sect_pjdtl').position().top },
      miriSecMove,
    );
    $('.tab-bottom-item').removeClass('is-current prev next');
    $(event.currentTarget).addClass('is-current');
    $(event.currentTarget)
      .prev()
      .addClass('prev');
    $(event.currentTarget)
      .next()
      .addClass('next');
    $('.pjdetail_article').removeClass('is-active');
    $('.pjdetail_article')
      .eq(t)
      .addClass('is-active');
    $('.tab-nav-item').removeClass('is-current');
    $('.tab-nav-item')
      .eq(t)
      .addClass('is-current');
  }

  // SPにて、プロジェクト概要のタブをクリック
  @on('click .btn_info_tab')
  onClickBtnInfoTab(event: any) {
    let t = $('.btn_info_tab').index(event.currentTarget);
    $('.btn_info_tab').removeClass('is-current');
    $(event.currentTarget).addClass('is-current');
    $('.tabContent').removeClass('is-active');
    $('.tabContent')
      .eq(t)
      .addClass('is-active');
  }

  // 投資メニューのバツボタンをクリック
  @on('click .close-button')
  onClickCloseButton() {
    $('.modal-content').css('right', '-100%');
    $('body').css('overflow', 'inherit');
    setTimeout(function() {
      $('#modal').css('display', 'none');
    }, 500);
  }

  // 投資メニューの切り替え（特定投資家コースか通常コースか）
  @on('click .modalTabs-nav-item')
  onClickModalTabsNavItem(event: any) {
    let t = $('.modalTabs-nav-item').index(event.currentTarget);
    $('.modalTabs-nav-item').removeClass('is-current');
    $(event.currentTarget).addClass('is-current');
    $('.radio-item').removeClass('is-active');
    $('.radio-item')
      .eq(t)
      .addClass('is-active');
  }

  // 投資コースの切り替え。通常コースの場合
  @on('change .product_radio_button')
  onChangProductRadioButton(event: any) {
    let impossible_button = $('#product_apply_button_impossible');
    if (impossible_button.length === 1) {
      if ($('#product_apply_button_impossible').css('display') === 'none') {
        $('#product_apply_button_impossible').css('display', 'inline-block');
      }
    }

    let confirm_button = $('#product_apply_button_stock_option_confirm');
    if (confirm_button.length === 1) {
      let url = $(event.currentTarget).data('stockOptionConfirmUrl');

      confirm_button.attr(
        'onclick',
        `$.ajax({type: 'GET',url: '${url}',data: { type: 'normal' }})`,
      );

      if (
        $('#product_apply_button_stock_option_confirm').css('display') ===
        'none'
      ) {
        $('#product_apply_button_stock_option_confirm').css(
          'display',
          'inline-block',
        );
      }
    }

    let apply_button = $('#product_apply_button');
    if (apply_button.length === 1) {
      let url = $(event.currentTarget).data('applyUrl');
      apply_button.attr('onclick', 'location.href =' + `"${url}"`);
      if (apply_button.css('display') === 'none') {
        apply_button.css('display', 'inline-block');
      }
    }
  }

  // 投資コースの切り替え。特定投資家コースの場合
  @on('change .product_radio_button_for_specific')
  onChangProductRadioButtonForSpecific(event: any) {
    let impossible_button = $('#product_apply_button_impossible_for_specific');
    if (impossible_button.length === 1) {
      if (
        $('#product_apply_button_impossible_for_specific').css('display') ===
        'none'
      ) {
        $('#product_apply_button_impossible_for_specific').css(
          'display',
          'inline-block',
        );
      }
    }

    let confirm_button = $(
      '#product_apply_button_stock_option_confirm_for_specific',
    );
    if (confirm_button.length === 1) {
      let url = $(event.currentTarget).data('stockOptionConfirmUrl');

      confirm_button.attr(
        'onclick',
        `$.ajax({type: 'GET',url: '${url}',data: { type: 'normal' }})`,
      );

      if (
        $('#product_apply_button_stock_option_confirm_for_specific').css(
          'display',
        ) === 'none'
      ) {
        $('#product_apply_button_stock_option_confirm_for_specific').css(
          'display',
          'inline-block',
        );
      }
    }

    let apply_button = $('#product_apply_button_for_specific');
    if (apply_button.length === 1) {
      let url = $(event.currentTarget).data('applyUrl');
      apply_button.attr('onclick', 'location.href =' + `"${url}"`);
      if (apply_button.css('display') === 'none') {
        apply_button.css('display', 'inline-block');
      }
    }
  }

  // SP時目次クリック
  @on('click .index-open')
  onClickIndexOpen() {
    $('.index-modal').css({ bottom: '0', visibility: 'visible' });
    $('.index-modal').addClass('is-open');
    $('body').css('overflow', 'hidden');
    $('.l-main').css('z-index', '9999');
  }

  // SP時目次の閉じるボタンクリック
  @on('click .closeBtn')
  onClickCloseBtn() {
    $('.index-modal').css({ bottom: '-100%', visibility: 'hidden' });
    $('.index-modal').removeClass('is-open');
    $('body').css('overflow', 'inherit');
  }

  @on('click .faq-list__btn')
  onClickFaqListBtn(event: any) {
    $(event.currentTarget).hide();
    $(event.currentTarget)
      .next()
      .slideToggle('fast');
  }
}
